module.exports = __webpack_public_path__ + "img/index-standard-1.ef6b4d42.png";